import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react'
import { siteConfig } from './config/siteConfig';

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
}
// Transform old URLS (from legacy d2g, such as; 
// https://data2go.nyc/map/?id=107*36047015900*ahdi_puma!undefined!ns*!other_pop_cd_506~ahdi_puma_1~sch_enrol_cd_112~age_pyramid_male_85_plus_cd_20~median_household_income_puma_397~median_personal_earnings_puma_400~dis_y_perc_puma_102~poverty_ceo_cd_417~unemployment_cd_408~pre_k_cd_107!*air_qual_cd~ahdi_puma*family_homeless_cd_245#10/40.8276/-73.9588
// https://data2godev.kinsta.cloud/map/?id=107*36047015900*ahdi_puma!undefined!ns*!other_pop_cd_506~ahdi_puma_1~sch_enrol_cd_112~age_pyramid_male_85_plus_cd_20~median_household_income_puma_397~median_personal_earnings_puma_400~dis_y_perc_puma_102~poverty_ceo_cd_417~unemployment_cd_408~pre_k_cd_107!*air_qual_cd~ahdi_puma*family_homeless_cd_245#10/40.8276/-73.9588
/*if (
  (['/map', '/cd', '/com', '/mobile'].some(path =>
    window.location.pathname.replace(/\/$/, '') === path
  )) &&
  window.location.search
) {
  window.location.href = 'https://data2go.nyc';
}*/

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // Strict mode will cause the app to render twice in development. 
  // React.StrictMode is a development tool that highlights potential issues in an application.
  // It activates additional checks and warnings for its descendants, such as:
  //
  // - Identifying components with unsafe lifecycles
  // - Warning about legacy string ref API usage
  // - Warning about deprecated findDOMNode usage
  // - Detecting unexpected side effects in the render phase
  // - Detecting legacy context API
  //
  // Note: Strict Mode runs only in development mode; it does not impact the production build.
  // It helps to ensure that components are ready for asynchronous rendering and helps
  // prevent issues by running checks and warning about them.
  <React.StrictMode> 
    {siteConfig.ctx === 'nyc' ? (
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY as string}
        options={posthogOptions}
      >
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
